import { FetchRoutesOptions, FetchDirectRoutesOptions, SERVER_ERROR_CODES } from './types'

export const ERROR_LIMIT_CODE = 429

export const fetchAirports = async (placeSubstring: string) => {
  const uri = encodeURI(`/api/places?place=${placeSubstring}`)

  try {
    const response = await fetch(uri)
    return await response.json()
  } catch (error) {
    throw error
  }
}

export const fetchRoutes = async (options: FetchRoutesOptions) => {
  const uri = encodeURI(
    `/api/route?source=${options.source}&destination=${options.destination}&date=${options.date}&by_arrival_date=${options.byArrival}`
  )

  try {
    const response = await fetch(uri)
    const code = response.status
    if (SERVER_ERROR_CODES.limitError === code) return Promise.reject(code)
    return await response.json()
  } catch (error) {
    throw error
  }
}

export const fetchDirectRoutes = async (options: FetchDirectRoutesOptions) => {
  const params = 'destination' in options ? `destination=${options.destination}` : `source=${options.source}`
  const uri = encodeURI(`/api/direct-route?${params}`)

  try {
    const response = await fetch(uri)
    return await response.json()
  } catch (error) {
    throw error
  }
}
